import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

function getCategory (data, vm) {
    let catData = ''
    if (data.category_id !== '') {
      catData = vm.$t('production_store.category') + ' : ' + data.category_id
    }
    return catData
  }

function getMonth (item, vm) {
    let data = ''
    if (item.monthname !== '') {
        data = { text: ' ' + vm.$t('sales_distribution_admin.month') + ' : ' + item.monthname, style: 'td', alignment: 'right' }
    }
    return data
}

function getSubCategory (data, vm) {
  let catData = ''
  if (data.sub_category_id !== '') {
    catData = vm.$t('production_store.sub_category') + ' : ' + data.sub_category_id
  }
  return catData
}

function getProduct (data, vm) {
    let catData = ''
    if (data.product_id !== '') {
      catData = vm.$t('production_store.product') + ' : ' + data.product_id
    }
    return catData
  }

function getcategoryName (catId) {
  const category = Store.state.ProductionService.commonObj.productCategoryList.find(item => item.value === catId)
  if (i18n.locale === 'bn') {
    return category.text_bn
  } else {
    return category.text_en
  }
}

function getSubcategoryName (prodData) {
  const gdata = []
  let subCatname = ''
  Object.entries(prodData).forEach(([key, value]) => {
    const productId = parseInt(key)
    const product = Store.state.ProductionService.commonObj.productList.find(item => item.value === productId)
    const subCatId = parseInt(product.sub_category_id)
    if (subCatId !== 0) {
      const subCatObj = Store.state.ProductionService.commonObj.productSubCategoryList.find(item => item.value === subCatId)
      if (i18n.locale === 'bn') {
        subCatname = subCatObj.text_bn
      } else {
        subCatname = subCatObj.text_en
      }
      gdata.push({ text: subCatname, style: 'td', alignment: 'center' })
    } else {
      gdata.push({ text: '', style: 'td', alignment: 'center' })
    }
  })
  return gdata
}

function getproductName (prodData) {
  const gdata = []
  let productNmae = ''
  Object.entries(prodData).forEach(([key, value]) => {
    const productId = parseInt(key)
    const product = Store.state.ProductionService.commonObj.productList.find(item => item.value === productId)
    if (i18n.locale === 'bn') {
      productNmae = product.text_bn
    } else {
      productNmae = product.text_en
    }
    gdata.push({ text: productNmae, style: 'td', alignment: 'center' })
  })
  return gdata
}

function getUnitName (prodData) {
  const gdata = []
  let unitName = ''
  Object.entries(prodData).forEach(([key, value]) => {
    Object.entries(value).forEach(([key, kvalue]) => {
      const unitId = parseInt(key)
      const unit = Store.state.ProductionService.commonObj.unitInfoList.find(item => item.value === unitId)
      if (i18n.locale === 'bn') {
        unitName = unit.text_bn
      } else {
        unitName = unit.text_en
      }
      gdata.push({ text: unitName, style: 'td', alignment: 'center' })
    })
  })
  return gdata
}
function getOpeningStock (prodData, vm) {
  const gdata = []
  Object.entries(prodData).forEach(([key, value]) => {
    Object.entries(value).forEach(([key, kvalue]) => {
      gdata.push({ text: vm.$n(kvalue.opening), style: 'td', alignment: 'center' })
    })
  })
  return gdata
}
function getCurrentStock (prodData, vm) {
  const gdata = []
  Object.entries(prodData).forEach(([key, value]) => {
    Object.entries(value).forEach(([key, kvalue]) => {
      gdata.push({ text: vm.$n(kvalue.current_stock), style: 'td', alignment: 'center' })
    })
  })
  return gdata
}
function getDisburseAmount (prodData, vm) {
  const gdata = []
  Object.entries(prodData).forEach(([key, value]) => {
    Object.entries(value).forEach(([key, kvalue]) => {
      gdata.push({ text: vm.$n(kvalue.disburse), style: 'td', alignment: 'center' })
    })
  })
  return gdata
}
function getFinalStock (prodData, vm) {
  const gdata = []
  Object.entries(prodData).forEach(([key, value]) => {
    Object.entries(value).forEach(([key, kvalue]) => {
      const opening = parseInt(kvalue.opening)
      const current = parseInt(kvalue.current_stock)
      const disburse = parseInt(kvalue.disburse)
      const finalstock = (opening + current) - disburse
      gdata.push({ text: vm.$n(finalstock), style: 'td', alignment: 'center' })
    })
  })
  return gdata
}

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                  { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                  { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
                ],
                [
                  {},
                  { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.address, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportTitle, style: 'address2', alignment: 'center' },
                  {}
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
        const allRowsHead = [
          [
            { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.category'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.sub_category'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.pro_name'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.unit'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.opening_stock'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.curren_stock'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.disbursement'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.final_stock'), style: 'th', alignment: 'center' }
          ]
        ]
        data.map((report, index) => {
          allRowsHead.push(
          [
            { text: index + 1, style: 'td', alignment: 'center' },
            { text: getcategoryName(report.category_id), style: 'td', alignment: 'center' },
            getSubcategoryName(report.products),
            getproductName(report.products),
            getUnitName(report.products),
            getOpeningStock(report.products, vm),
            getCurrentStock(report.products, vm),
            getDisburseAmount(report.products, vm),
            getFinalStock(report.products, vm)
          ])
        })
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['50%', '50%'],
              body: [
                [
                    { text: getCategory(titleData, vm), style: 'td', alignment: 'left' },
                    { }
                ],
                [
                    { text: getSubCategory(titleData, vm), style: 'td', alignment: 'left' },
                    { text: titleData.year, style: 'td', alignment: 'right' }
                ],
                [
                    { text: getProduct(titleData, vm), style: 'td', alignment: 'left' },
                    getMonth(titleData, vm)
                ]
              ]
            },
            layout: {
                hLineWidth: function (i, node) {
                  return 0
                },
                vLineWidth: function (i, node) {
                  return 0
                }
              }
          }
        )
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['5%', '*', '*', '*', '*', '*', '*', '*', '*'],
            body: allRowsHead
          }
        })
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'landscape',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
            th: {
                fillColor: '#dee2e6',
                fontSize: 10,
                margin: [3, 3, 3, 3]
              },
            th1: {
                fontSize: 9
              },
            td: {
              fontSize: 8,
              margin: [3, 3, 3, 3]
            },
            header: {
              margin: [0, 1, 0, 15],
              fontSize: 16,
              alignment: 'center'
            },
            header2: {
              border: 0,
              fontSize: 14,
              margin: [0, 0, 0, 1]
            },
            govt_info: {
              margin: [0, 1, 0, 1],
              fontSize: 18,
              alignment: 'center'
            },
            address2: {
              border: 0,
              fontSize: 12,
              bold: true,
              margin: [0, 0, 0, 5]
            },
            left_logo: {
              borderRadius: 50
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
